import {
  fireDataLayerEvent,
  trackVisit,
  updateAndSyncDatalayer,
} from './datalayer';
import type { DatalayerTrackingClient } from './types';

export const createDatalayerTrackingClient = (
  _params?: unknown
): DatalayerTrackingClient => {
  return {
    trackVisit,
    trackEvent: fireDataLayerEvent,
    save: updateAndSyncDatalayer,
  };
};
